<template>
  <div>
    <div class="dark-card">
      <div class="info">住戶名稱</div>
      <div class="main">{{ bindingHouseFee.name }}</div>
    </div>
    <div class="content">
      <div class="key text-gray2">社宅名稱</div>
      <div class="value text-gray1">{{ bindingHouseFee.housing_site_name }}</div>
    </div>

    <div class="content">
      <div class="key text-gray2">承租起始時間</div>
      <div class="value text-gray1">{{ bindingHouseFee.date_of_start_rent }}</div>
    </div>

    <div class="content">
      <div class="key text-gray2">承租結束時間</div>
      <div class="value text-gray1">{{ bindingHouseFee.date_of_end_rent }}</div>
    </div>

    <div class="div-bottom">
      <div class="div-bottom-content text-gray2">綁定後如有新的社宅帳單，將會主動通知您！</div>
      <div class="div-bottom-btn">
        <button class="text-nowrap btn btn-primary" @click="bindHouse">綁定住戶資料</button>
      </div>
    </div>
  </div>
</template>
<script>
import { bindHouse } from '../../api/api';

export default {
  name: 'bind-house-fee',
  data() {
    return {
      bindingHouseFee: JSON.parse(sessionStorage.getItem('bindingHouseFee')),
    };
  },
  methods: {
    bindHouse() {
      bindHouse().then((res) => {
        if (!res.error) {
          alert('已完成綁定');
          this.$router.back();
        } else {
          alert(res.error.message);
        }
      });
    },
  },
};
</script>
<style type="text/css" lang="scss" scoped>
.dark-card {
  margin: 20pt;
  padding: 24pt;
}

.dark-card .info {
  color: #c7c7c7;
  font-size: 16px;
  margin-bottom: 5pt;
}

.dark-card .main {
  font-size: 22px;
}

.content {
  background-color: #fff;
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;

  &:not(:last-child):after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    height: 1px;
    background-color: rgba(64, 64, 64, 0.1);
  }
}

.div-bottom {
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 130pt;
  display: flex;
  flex-direction: column;
  align-items: center;

  .div-bottom-content {
    padding: 16pt 12px;
    margin: 0 auto;
    font-size: 14px;
  }

  .div-bottom-btn {
    width: 90%;
  }
}
</style>
